import API from '../../../../commons/api/api';
import * as actionTypes from '../actions/type';

export const initialState = {
  albums: {
    'all': {},
    'image_card': null,
    'character_selfie': null,
    'video_message': null,
  },
  item: null,
  isProcessingItem: null,
  isProcessing: null,
  coutingVideo: 1,
  lastPage: 1,
  currentPage: 1,
  typeMsg: ''
};

const albumReducers = (state  = initialState, action) => {
  const { payload } = action;
  switch (action.type) {

    case actionTypes.GET_ALBUM:
      return { 
        ...state, 
        isProcessing: true, 
        type: action.type, 
        typeMsg: action.params.type,
        lastPage: state.typeMsg === action.params.type ? state.lastPage : 1
      };
    case actionTypes.GET_ALBUM_SUCCESS:
      return {
        ...state,
        isProcessing: false,
        albums: {
          ...state.albums,
          [payload.type || 'all']: payload.data?.current_page == 1 ? 
          payload.data.data : {...state.albums?.[payload.type || 'all'], ...payload.data.data} 
        },
        lastPage: payload.data?.last_page,
        currentPage: payload.data?.current_page,
        typeMsg: payload.type
      };

    case actionTypes.GET_ALBUM_DETAIL:
      return { 
        ...state, 
        isProcessingItem: true, 
        item: null, 
        type: action.type 
      };
    case actionTypes.GET_ALBUM_DETAIL_SUCCESS:
      return {
        ...state,
        isProcessingItem: false,
        item: payload.data
      };

      case actionTypes.DETETE_ALBUM_REQUEST:
        return { 
          ...state, 
          isProcessing: true, 
          type: action.type 
        };
      case actionTypes.DETETE_ALBUM_SUCCESS:
        return {
          ...state,
          isProcessing: false,
        };

      case actionTypes.RESET_ALBUM_SUCCESS:
        return {
          ...state,
          item: null,
          isProcessingItem: null,
        };
      case actionTypes.RESET_DATA_ALBUM_SUCCESS:
        return {
          albums: {
            'all': {},
            'image_card': null,
            'character_selfie': null,
            'video_message': null,
          },
          item: null,
          isProcessingItem: null,
          isProcessing: null,
          coutingVideo: 1,
          lastPage: 1,
          currentPage: 1,
          typeMsg: ''
        };
      case actionTypes.UPDATE_ALBUM_BADGE_COUNT:
        return {
          ...state,
          badgeCount: payload
        };
    default:
      return state;
  }
};

export default albumReducers;
